import type { KambiReward, KambiValidReward } from '@mobi/api-types/kambi/player/reward'
import { roundDownDecimal } from '@mobi/betslip/helpers/calculator/misc'
import { formatKambiCurrencyToDollarDecimal } from '@mobi/sports-offering/helpers/currency/currencyFormat'
import { Currency } from '@mobi/utils/money'

/** @requires price to be in dollar decimal value  */
export function calculateKambiSelectionBoostedPriceWithReward(
  price: number,
  reward: KambiValidReward
): number {
  if (reward.rewardType === 'ODDS_BOOST' && reward.oddsBoostProperties) {
    return formatKambiCurrencyToDollarDecimal(reward.oddsBoostProperties.boostedOdds)
  }

  if (reward.rewardType === 'PROFIT_BOOST' && reward.profitBoostProperties) {
    return applyPercentageBoost(price, reward.profitBoostProperties.boostPercentage)
  }

  return price
}

export function getBoostedPriceWithReward(price: number, reward: KambiReward | null): number {
  if (!reward) return 0

  const rewardTypesWithBoost: KambiReward['rewardType'][] = ['ODDS_BOOST', 'PROFIT_BOOST']
  if (rewardTypesWithBoost.includes(reward.rewardType)) {
    return calculateKambiSelectionBoostedPriceWithReward(price, reward)
  }

  return 0
}

// =============
// Local Helpers
// =============

function applyPercentageBoost(price: number, boostPercent: number): number {
  return roundDownDecimal(
    new Currency(price)
      // Convert boost percent to multiplier ie. 1.1 = 10%
      .multiply(1 + boostPercent / 100)
      // Deduct winnings percent
      .subtract(boostPercent / 100).rawValue
  )
}
